export default __webpack_public_path__ + "static/media/Mystic's Cover of Yag.a616cf49.jpg";